import { MenuDropdown } from '@/components/Common';

import { Divider } from 'primereact/divider';
import { FormConfigExam } from './FormConfigExam';
import { Button } from '@/components/Common';
import { ListItem } from '@/components/Ui';
import { AddGift } from './AddGift';
import { useEffect } from 'react';
import { useGetExamConfigs } from '@/api/hooks/useExamConfig';
import type { GiftOutput } from '@/api/gql/graphql';
import { createMenuItem } from '@/components/Common/DropdownMenu/MenuDropdown.utils';
import GiftDeletionModal from './GiftDeletionModal';
import { AddDisciplineWithLesson } from './AddDisciplineWithLesson';
import { useDisciplineWithLessonStore } from '@/store/ExamStore/DisciplineWithLessonStore';
import { useDisciplineModalManager } from './useDisciplineModalManager';

export const ViewConfigExam = () => {
  const { data: examConfigs } = useGetExamConfigs();
  const disciplinesWithLessons = useDisciplineWithLessonStore(
    (state) => state.disciplinesWithLessons,
  );
  const removeDisciplineWithLesson = useDisciplineWithLessonStore(
    (state) => state.removeDisciplineWithLesson,
  );
  const syncWithServerData = useDisciplineWithLessonStore(
    (state) => state.syncWithServerData,
  );
  const updateDisciplineWithLesson = useDisciplineWithLessonStore(
    (state) => state.updateDisciplineWithLesson,
  );

  const {
    open,
    setOpen,
    openDisciplineWithLesson,
    setOpenDisciplineWithLesson,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    selectedGiftId,
    setSelectedGiftId,
    editingDiscipline,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleEditDiscipline,
    handleCloseDisciplineModal,
  } = useDisciplineModalManager(disciplinesWithLessons);

  useEffect(() => {
    if (examConfigs?.[0]?.disciplinesWithLessons) {
      syncWithServerData(examConfigs[0].disciplinesWithLessons);
    }
  }, [examConfigs, syncWithServerData]);

  const getGiftMenuItems = (id: string) => [
    createMenuItem('Supprimer', 'font-[400] text-red-700', () =>
      handleOpenDeleteModal(id),
    ),
  ];

  const getDisciplineMenuItems = (index: number) => [
    createMenuItem('Modifier', 'font-[400]', () => handleEditDiscipline(index)),
    createMenuItem('Supprimer', 'font-[400] text-red-700', () =>
      removeDisciplineWithLesson(index),
    ),
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[minmax(600px,_1.3fr)_auto_1fr] gap-0 items-start mb-10">
      <FormConfigExam />
      <div className="flex justify-center">
        <Divider
          layout="vertical"
          className="bg-dimGray w-[1px] h-[858px] mx-8"
        />
      </div>
      <div>
        <div className="w-[510px] h-[400px] overflow-y-auto">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-[20px] font-bold text-white">Cadeaux</h2>
            <Button title="Ajouter un cadeau" onClick={() => setOpen(true)} />
          </div>
          {examConfigs?.[0]?.gifts.map((item: GiftOutput, index: number) => (
            <ListItem
              key={index}
              listItemStyle="!bg-black !rounded-l-xl !border-l-[13px]"
            >
              <div className="flex items-center justify-between">
                <p>{item.name}</p>
                <button>
                  <MenuDropdown
                    menuItems={getGiftMenuItems(item._id)}
                    dotsStyle="bg-mikadoYellow"
                  />
                </button>
              </div>
            </ListItem>
          ))}
        </div>
        <div className="w-[510px] h-[600px] overflow-y-auto">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-[20px] font-bold text-white">Matieres</h2>
            <Button
              title="Ajouter une discipline"
              onClick={() => setOpenDisciplineWithLesson(true)}
            />
          </div>
          <div className="flex flex-col gap-4">
            {disciplinesWithLessons.map((item, index) => (
              <ListItem
                key={index}
                listItemStyle="!bg-black !rounded-l-xl !border-l-[13px]"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-bold">
                      {typeof item.discipline === 'string'
                        ? item.discipline
                        : item.discipline.name}
                    </p>
                    {item.lessons.length > 0 && (
                      <p className="text-sm text-gray-400">
                        {item.lessons.length} leçons sélectionnées
                      </p>
                    )}
                  </div>
                  <button>
                    <MenuDropdown
                      menuItems={getDisciplineMenuItems(index)}
                      dotsStyle="bg-mikadoYellow"
                    />
                  </button>
                </div>
              </ListItem>
            ))}
          </div>
        </div>
      </div>
      <AddGift isOpen={open} onClose={() => setOpen(false)} />
      <AddDisciplineWithLesson
        isOpen={openDisciplineWithLesson}
        onClose={handleCloseDisciplineModal}
        editingDiscipline={editingDiscipline}
        onUpdate={(updatedDiscipline) => {
          if (editingDiscipline) {
            updateDisciplineWithLesson(
              editingDiscipline.index,
              updatedDiscipline,
            );
          }
        }}
      />
      <GiftDeletionModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        examConfigId={examConfigs?.[0]?._id || ''}
        giftId={selectedGiftId || ''}
      />
    </div>
  );
};
